module.exports = __webpack_public_path__ + "img/Assessment1.0b3ea4f5.jpg";